import React, { useState, ReactNode } from "react";
import { useSpring, animated } from "react-spring";
// eslint-disable-next-line
// @ts-ignore the styled components typescript def hasn't been updated yet
import styled from "styled-components";

const StyledCard = styled(animated.div)`
  //Overflow is set to auto so that the scrollbar will only appear if needed, and will not bleed past the general web content
  overflow: auto;
  border-radius: ${({ theme }) => theme.deprecatedBorder.radius.large};
  box-shadow: ${({ theme }) => theme.deprecatedElevation.two};
`;

export default function Card({
  children,
  className,
  animateOnHover = false,
  onClick,
  dataTest,
}: {
  children: ReactNode;
  className?: string;
  animateOnHover?: boolean;
  onClick?: () => void;
  dataTest?: string;
}) {
  const [hover, setHover] = useState<boolean>(false);
  const props = useSpring({
    transform: hover && animateOnHover ? "scale(1.01)" : "scale(1)",
    config: {
      duration: 80,
    },
  });
  return (
    <StyledCard
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      className={className}
      style={!animateOnHover ? undefined : props}
      data-test={dataTest}
    >
      {children}
    </StyledCard>
  );
}

export const StyledCardTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: ${({ theme }) => theme.deprecatedColors.white};
  border-bottom: ${({ theme }) => theme.deprecatedColors.gray.eight};
  margin-bottom: ${({ theme }) => theme.deprecatedSpacing.component.one};
  padding: ${({ theme }) =>
    `${theme.deprecatedSpacing.component.five} ${theme.deprecatedSpacing.component.six}`};
  border-top-left-radius: ${({ theme }) => theme.deprecatedBorder.radius.large};
  border-top-right-radius: ${({ theme }) => theme.deprecatedBorder.radius.large};
`;
